module.exports = __webpack_public_path__ + "img/FR14658.d9c06ece.png";